'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'user-headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f82d';
var svgPathData = ['M16 512c8.8 0 16-7.2 16-16 0-61.9 50.1-112 112-112l160 0c61.9 0 112 50.1 112 112 0 8.8 7.2 16 16 16L16 512zM144 160c0-44.2 35.8-80 80-80s80 35.8 80 80c0 9.3-1.6 18.1-4.5 26.4-13.1-6.7-27.9-10.4-43.5-10.4l-64 0c-15.7 0-30.5 3.8-43.5 10.4-2.9-8.3-4.5-17.2-4.5-26.4z', 'M224 16C144.5 16 80 80.5 80 160l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C48 62.8 126.8-16 224-16S400 62.8 400 160l0 144c0 8.8-7.2 16-16 16l-192 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l64 0c26.5 0 48 21.5 48 48 0 5.6-1 11-2.7 16l66.7 0 0-128c0-79.5-64.5-144-144-144zm32 272c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm48-128c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 9.3 1.6 18.1 4.5 26.4-10 5.1-18.9 11.8-26.5 19.9-6.4-14.1-10-29.8-10-46.3 0-61.9 50.1-112 112-112S336 98.1 336 160c0 16.5-3.6 32.2-10 46.3-7.6-8.1-16.5-14.8-26.5-19.9 2.9-8.3 4.5-17.2 4.5-26.4zM32 496c0 8.8-7.2 16-16 16S0 504.8 0 496c0-79.5 64.5-144 144-144l160 0c79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112l-160 0C82.1 384 32 434.1 32 496z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;